/* global admin_vars */

jQuery(function($){

  $('.resource-filters').change(function(){
    var filter = $('#resource-filters');
    $.ajax({
      url:admin_vars.ajax_url,
      type:'POST',
      data: {
        'action': 'process_filter_request',
        'vars': filter.serialize(),
        'nonce':admin_vars.nonce
      },
      beforeSend:function(xhr){
        $('.loading').show();
      },
      success:function(data){
        $("#insights-listing").html(data).addClass("animated fadeIn");
        $('.loading').hide(); //<--- hide again
      },
      error: function(errorThrown) {
        console.log(errorThrown);
      },
      complete: function(msg) {
        // Update the UI here to reflect completion
        //Foundation.reInit('equalizer');
        console.log('Ajax request commpleted successfully!');
      }
    });
    return false;
  });


  $('.links-dropdown-button').click(function(){

    var url = $(this).closest('.links-dropdown-container').find(".links-dropdown option:selected").val();
    if(url){
      // window.location.href(url);
      $(location).attr('href', url);
    }

  });

/*
  $("#categories-dropdown").change(function(e) {

    $("#insights-listing").removeClass("animated fadeIn");
    var catID = $('#categories-dropdown option:selected').val();
    setTimeout(function() {
      $('.loading').show(); //<--- hide again
      // This does the ajax request
      $.ajax({
        url: admin_vars.ajax_url,
        type: 'POST',
        data: {
          'action': 'process_category_request',
          'catID': catID,
          'nonce':admin_vars.nonce
        },
        success: function(data) {
          $("#insights-listing").html(data).addClass("animated fadeIn");
          $('.loading').hide(); //<--- hide again
        },
        error: function(errorThrown) {
          console.log(errorThrown);
        },
        complete: function(msg) {
          // Update the UI here to reflect completion
          //Foundation.reInit('equalizer');
          console.log('Ajax request commpleted successfully!');
        }
      });

    }, 300);

    return false;

  });
*/


  $('.grid-nav').on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });

});

